import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_179: DocMigration = {
  maxSchemaVersion: "0.0.179",
  description: "Migrate Lateral Foundation Datums to foundationDatums",
  apply(json: any) {
    if (json.settings) {
      for (const settingId in json.settings) {
        const setting = json.settings[settingId];
        if (setting.type === "FOUNDATION_CATALOG_SETTINGS") {
          const foundationDatums = setting.foundationDatums ?? {};
          if (setting.foundationAssemblies !== undefined) {
            for (const assemblyId in setting.foundationAssemblies) {
              const assembly = setting.foundationAssemblies[assemblyId];
              const { assemblyDatum, assemblyDatumOffset } = assembly;
              if (assemblyDatum !== undefined || assemblyDatumOffset !== undefined) {
                const datum = {
                  datumType: "LATERAL",
                  name: `Wall Datum for ${assembly.name}`,
                  anchor: assemblyDatum,
                  offset: assemblyDatumOffset,
                };
                const datumId = uid();
                foundationDatums[datumId] = datum;
                assembly.lateralDatumId = datumId;
              }
              delete assembly.assemblyDatum;
              delete assembly.assemblyDatumOffset;
            }
          }
          setting.foundationDatums = foundationDatums;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_179;
